/* __next_internal_client_entry_do_not_use__ CheckOutline auto */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import React from "react";
import { createSVGIcon } from "../util";
/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1777))
 * @trackcomponent
 * @lastsynced 2023-07-10T21:44:59.554Z
 */ export var CheckOutline = createSVGIcon(/*#__PURE__*/ _jsxs(_Fragment, {
    children: [
        /*#__PURE__*/ _jsx("path", {
            d: "M0.857178 12C0.857178 14.9553 2.03115 17.7895 4.12085 19.8792C6.21054 21.9689 9.04477 23.1429 12 23.1429C14.9553 23.1429 17.7895 21.9689 19.8792 19.8792C21.9689 17.7895 23.1429 14.9553 23.1429 12C23.1429 9.04477 21.9689 6.21054 19.8792 4.12085C17.7895 2.03115 14.9553 0.857178 12 0.857178C9.04477 0.857178 6.21054 2.03115 4.12085 4.12085C2.03115 6.21054 0.857178 9.04477 0.857178 12V12Z",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M7.35718 13.1064L9.31003 15.6179C9.37573 15.7023 9.45954 15.7709 9.55529 15.8186C9.65104 15.8663 9.75628 15.8919 9.86324 15.8934C9.97019 15.895 10.0761 15.8725 10.1733 15.8277C10.2704 15.7828 10.3562 15.7168 10.4243 15.6343L16.6429 8.10645",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    ]
}), "CheckOutline", {
    viewBox: "0 0 24 24",
    fill: "none",
    color: Core.icon.default
} // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
